import store  from '@/store'
import { DataSourceResult } from "@/models/DataSourceResult";
import { MetadataMaskyooStatus } from '@/models/MetadataMaskyooStatus';
import { PhoneLeadStats, PhoneStat } from "@/models/leads/LeadStatistic";
import { PhoneStatus, PhoneWithChannel } from "@/models/phones/PhoneWithChannel";
import HelperService from "./HelperService";

const namespace = "phonesModule";

export default {
  resetFilters(clientUser: boolean): void {
    store.dispatch(`${ namespace }/setDatePeriod`, HelperService.getThisMonthPeriod(), { root: true });
    store.dispatch(`${ namespace }/setSelectedCallStatus`, MetadataMaskyooStatus.All, { root: true });
    store.dispatch(`${ namespace }/setSelectedChannelMetadataTypesIds`, [], { root: true });
    if (!clientUser) {
      store.dispatch(`${ namespace }/setSelectedCompaniesIds`, [], { root: true });
    }
    store.dispatch(`${ namespace }/setSelectedPhoneStatus`, PhoneStatus.Active, { root: true });
    store.dispatch(`${ namespace }/setSelectedSourcesIds`, [], { root: true });
  },

  setStatsForPhones(phonesResult: DataSourceResult, phoneLeadStats: PhoneLeadStats): DataSourceResult {
    const newPhones: DataSourceResult = JSON.parse(JSON.stringify(phonesResult));
    for (const phone of newPhones.Data as PhoneWithChannel[]) {
      const phoneStat: (PhoneStat | undefined) = phoneLeadStats.PhoneStats.find((i: PhoneStat) => {
        return i.ToPhoneNumber === phone.PhoneNumber;
      });
      if (phoneStat) {
        if (phoneStat.NumberOfAnsweredCalls + phoneStat.NumberOfMissedCalls > 0) {
          const averageCallSeconds: number = phoneStat.DurationOfCalls / (phoneStat.NumberOfAnsweredCalls + phoneStat.NumberOfMissedCalls);
          phone.AverageCallSeconds = HelperService.getTimeStringFromSeconds(averageCallSeconds);
        }
        phone.NumberOfAnsweredCalls = phoneStat.NumberOfAnsweredCalls;
        phone.NumberOfMissedCalls = phoneStat.NumberOfMissedCalls;
        phone.TotalCallSeconds = HelperService.getTimeStringFromSeconds(phoneStat.DurationOfCalls);
      }
    }
    return newPhones;
  },
};
